import { Button } from '@utilities';
import type { ButtonProps } from '@utilities/components/Button';
import { useCanPreviewSurveys } from '../../utilities';

interface PreviewButtonProps extends ButtonProps {
  location: string;
}

const PreviewButton = ({ location, ...props }: PreviewButtonProps) => {
  const canPreview = useCanPreviewSurveys();
  if (!canPreview) return null;
  return (
    <Button
      aria-label={`open survey preview from ${location}`}
      data-testid={`${location.replaceAll(' ', '-')}-preview-button`}
      text="Preview"
      variant="secondary"
      {...props}
    />
  );
};

export default PreviewButton;
